import React, { useState, useEffect } from "react";
import { Switch, Dimensions } from "react-native";
import StyleSheetRW from "core/StyleSheetRW";
import Menu from "./Menu";
import Dialog from "src/components/Dialog";
import { getLocalStorageItem } from "core/helpers";
import { ref, get, set } from "firebase/database";
import { db } from "@react-native-firebase/database";
import { fetchUserNotificationPreferences } from "src/utils/UserUtils";

const UserSettingScreen = () => {
    const screenWidth = Dimensions.get('window').width;
    const [isEnabled, setIsEnabled] = useState(false);
    const [timeOffEnabled, setTimeOffEnabled] = useState(false);
    const [chatEnabled, setChatEnabled] = useState(false);
    const [notificationPermission, setNotificationPermission] = useState(Notification.permission);
    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);
    const loggedinUser = getLocalStorageItem("loggedinUser");

    const updateUserPreference = async (preference: any) => {
        const dbRef = ref(db, `notification/${loggedinUser.uid}`);
        try {
            await set(dbRef, preference);
            console.log("User preferences updated successfully");
        } catch (error) {
            console.error("Error updating user preferences:", error);
        }
    };

    useEffect(() => {
        const initializePreferences = async () => {
            try {
                const data = await fetchUserNotificationPreferences(loggedinUser.uid);
                if (data) {
                    setNotificationPermission(data.applicationEnabled || "default");
                    setTimeOffEnabled(data.timeOffEnabled || false);
                    setChatEnabled(data.chatEnabled || false);
                    setIsEnabled(data.applicationEnabled === "granted");
                }
            } catch (error) {
                console.error("Error initializing user preferences:", error);
            }
        };

        initializePreferences();
    }, []);

    const toggleMainSwitch = async () => {
        if (isEnabled) {
            setIsEnabled(false);
            setChatEnabled(false)
            setTimeOffEnabled(false)
            setNotificationPermission("denied");
            await updateUserPreference({ applicationEnabled: "denied", timeOffEnabled: false, chatEnabled: false });
        } else {
            const permission = await Notification.requestPermission();
            setNotificationPermission(permission);
            if (permission === "granted") {
                setIsEnabled(true);
                await updateUserPreference({ applicationEnabled: permission , timeOffEnabled, chatEnabled });
            } else {
                setToastMessage(
                    permission === "denied"
                        ? "You have denied notification permission. Please enable it in your browser settings."
                        : "You need to allow notification permission to enable this feature. Please enable it"
                );
                setShowToast(true);
                await updateUserPreference({ applicationEnabled: permission, timeOffEnabled, chatEnabled });
            }
        }
    };

    const toggleTimeOffNotification = async () => {
        const newValue = !timeOffEnabled;
        setTimeOffEnabled(newValue);
        await updateUserPreference({ applicationEnabled: notificationPermission, timeOffEnabled: newValue, chatEnabled });
    };

    const toggleChatNotification = async () => {
        const newValue = !chatEnabled;
        setChatEnabled(newValue);
        await updateUserPreference({ applicationEnabled: notificationPermission, timeOffEnabled, chatEnabled: newValue });
    };

    return (
        <div style={styles.mainContainer}>
            <Menu />
            <Dialog
                message={toastMessage}
                onDialogClose={() => setShowToast(false)}
                isDialogVisible={showToast}
                title="Error"
                confirmText="Okay"
            />
            <div style={{...styles.upperContainer,width: screenWidth < 600 ? "100%" : "97%",}}>
                <div style={{ width: screenWidth < 600 ? "90%" : "98%",  }}>
                    <div style={{ width: "100%" }}>
                        <h1 style={styles.heading}>Settings</h1>
                        <div style={{ ...styles.timerContainer, opacity: isEnabled ? 1 : 0.7 }}>
                            <div style={styles.notificationTitle}>Allow Notifications</div>
                            <Switch
                                trackColor={{ false: "#767577", true: "#2F4858" }}
                                thumbColor={isEnabled ? "#ffffff" : "#f4f3f4"}
                                ios_backgroundColor="#3e3e3e"
                                onValueChange={toggleMainSwitch}
                                value={isEnabled}
                            />
                        </div>
                        {isEnabled && (
                            <>
                                <div style={{ ...styles.timerContainer, marginTop: 30 }}>
                                    <div style={styles.notificationTitle}>TimeOff Notification</div>
                                    <Switch
                                        trackColor={{ false: "#767577", true: "#2F4858" }}
                                        thumbColor={timeOffEnabled ? "#ffffff" : "#f4f3f4"}
                                        ios_backgroundColor="#3e3e3e"
                                        onValueChange={toggleTimeOffNotification}
                                        value={timeOffEnabled}
                                    />
                                </div>
                                <div style={styles.timerContainer}>
                                    <div style={styles.notificationTitle}>Chat Notification</div>
                                    <Switch
                                        trackColor={{ false: "#767577", true: "#2F4858" }}
                                        thumbColor={chatEnabled ? "#ffffff" : "#f4f3f4"}
                                        ios_backgroundColor="#3e3e3e"
                                        onValueChange={toggleChatNotification}
                                        value={chatEnabled}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const styles = StyleSheetRW.create(() => ({
    mainContainer:{ display: "flex", flexDirection: "row", height: "100%" },
    upperContainer:{ overflowX: "hidden",  padding: '0px 0px 0px 20px' },
    container: {
        flex: 1,
        width: "100%",
        height: "100%",
        overflow: "scroll"
    },
    notificationTitle:{ fontSize: 22, color: '#2F4858', fontWeight: "bold" },
    heading: {
        fontWeight: 'bold',
        fontSize: 32,
        color: '#2F4858',
        marginTop: 20
    },
    timerContainer: {
        width: '96%',
        backgroundColor: '#e8f0eb',
        display: 'flex',
        flexDirection: "row",
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '8px',
        gap: '9px',
        padding: "13px 18px",
        borderRadius: 50
    },
}));

export default UserSettingScreen;